/**
 * ショートカットの共通判定（docs/design/layout-and-navigation.md §4.2 の衝突の規則）。
 */

const EDITABLE_SELECTOR =
  'input, textarea, select, [contenteditable]:not([contenteditable="false"]), .cm-editor';

/** フォーカスが文字入力の中にあるか。文字キーと矢印はショートカットとして扱わない */
export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  const el = target.closest(EDITABLE_SELECTOR);
  if (!el) return false;
  if (el instanceof HTMLInputElement) {
    // ボタン類の input は文字を受け付けない
    const nonText = ['button', 'submit', 'reset', 'checkbox', 'radio', 'range', 'file', 'color'];
    if (nonText.includes(el.type)) return false;
    return !el.readOnly && !el.disabled;
  }
  if (el instanceof HTMLTextAreaElement) return !el.readOnly && !el.disabled;
  return true;
}

/** 修飾キー（Shift を除く）が押されているか。ブラウザや OS のショートカットを横取りしない */
export function hasCommandModifier(e: KeyboardEvent): boolean {
  return e.metaKey || e.ctrlKey || e.altKey;
}

/** ⌘ / Ctrl + Enter */
export function isSubmitChord(e: KeyboardEvent): boolean {
  return e.key === 'Enter' && (e.metaKey || e.ctrlKey) && !e.altKey;
}

export const IS_MAC =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

export const SUBMIT_CHORD_LABEL = IS_MAC ? '⌘ Enter' : 'Ctrl Enter';
